import { UserProfile } from '../../domain/models/user.model';
import { Action, AnyAction } from '../action.type';
import { AppState } from '../app.state';
import { initialAuthenticationState } from '../authentication/authentication.state';
import {
  CREATE_USER_PROFILE,
  CREATE_USER_PROFILE_FAILURE,
  CREATE_USER_PROFILE_SUCCESS,
  DELETE_USER_PROFILE,
  DELETE_USER_PROFILE_FAILURE,
  DELETE_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE,
  GET_USER_PROFILE_FAILURE,
  GET_USER_PROFILE_SUCCESS,
  SET_USER_ERROR,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_FAILURE,
  UPDATE_USER_PROFILE_SUCCESS,
} from './user.action.type';
import { initialUserState } from './user.state';

export const userReducers = (state: AppState, action: AnyAction): AppState => {
  switch (action.type) {
    case GET_USER_PROFILE:
      return getUserProfile(state, action);
    case GET_USER_PROFILE_SUCCESS:
      return getUserProfileSuccess(state, action);
    case GET_USER_PROFILE_FAILURE:
      return getUserProfileFailure(state, action);
    case CREATE_USER_PROFILE:
      return createUserProfileReducer(state, action);
    case CREATE_USER_PROFILE_SUCCESS:
      return createUserProfileSuccessReducer(state, action);
    case CREATE_USER_PROFILE_FAILURE:
      return createUserProfileFailureReducer(state, action);
    case UPDATE_USER_PROFILE:
      return updateUserProfileReducer(state, action);
    case UPDATE_USER_PROFILE_SUCCESS:
      return updateUserProfileSuccessReducer(state, action);
    case UPDATE_USER_PROFILE_FAILURE:
      return updateUserProfileFailureReducer(state, action);
    case SET_USER_ERROR:
      return setUserErrorReducer(state, action);
    case DELETE_USER_PROFILE:
      return deleteUserProfileReducer(state, action);
    case DELETE_USER_PROFILE_SUCCESS:
      return deleteUserProfileSuccessReducer(state, action);
    case DELETE_USER_PROFILE_FAILURE:
      return deleteUserProfileFailureReducer(state, action);
    default:
      return state;
  }
};

const getUserProfile = (state: AppState, _action: Action<void>): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      isLoading: true,
    },
  };
};

const getUserProfileSuccess = (
  state: AppState,
  action: Action<UserProfile>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      profile: action.payload,
      isLoading: false,
    },
  };
};

const getUserProfileFailure = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      error: action.payload,
      isLoading: false,
    },
  };
};

const createUserProfileReducer = (
  state: AppState,
  _action: Action<void>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      isLoading: true,
    },
  };
};

const createUserProfileSuccessReducer = (
  state: AppState,
  action: Action<UserProfile>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      profile: action.payload,
      isLoading: false,
    },
  };
};

const createUserProfileFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      error: action.payload,
      isLoading: false,
    },
  };
};

const updateUserProfileReducer = (
  state: AppState,
  action: Action<void>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      isLoading: true,
      error: null,
    },
  };
};

const updateUserProfileSuccessReducer = (
  state: AppState,
  action: Action<UserProfile>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      profile: action.payload,
      isLoading: false,
    },
  };
};

const updateUserProfileFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      error: action.payload,
      isLoading: false,
    },
  };
};

const setUserErrorReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      error: action.payload,
    },
  };
};

const deleteUserProfileReducer = (
  state: AppState,
  _action: Action<void>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      isLoading: true,
    },
    // setting auth state as deletion affects both user & authentication
    authentication: {
      ...state.authentication,
      isLoading: true,
    },
  };
};

const deleteUserProfileSuccessReducer = (
  state: AppState,
  _action: Action<void>,
): AppState => {
  return {
    ...state,
    user: initialUserState,
    // setting auth state as deletion affects both user & authentication
    authentication: initialAuthenticationState,
  };
};

const deleteUserProfileFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    user: {
      ...state.user,
      error: action.payload,
      isLoading: false,
    },
    // setting auth state as deletion affects both user & authentication
    authentication: {
      ...state.authentication,
      isLoading: false,
    },
  };
};
